function holidayOrderBusinessDate(now, timeZone) {
  let formatter;
  try { formatter = new Intl.DateTimeFormat('en-US', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }); }
  catch { formatter = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' }); }
  const parts = Object.fromEntries(formatter.formatToParts(now).map(part => [part.type, part.value]));
  return `${parts.year}-${parts.month}-${parts.day}`;
}

function holidayOrderIsCurrent(start, end, today) {
  const valid = value => /^\d{4}-\d{2}-\d{2}$/.test(value || '') && !Number.isNaN(Date.parse(`${value}T00:00:00Z`)) && new Date(`${value}T00:00:00Z`).toISOString().slice(0, 10) === value;
  // A valid end date is required, so a cleared or malformed date cannot leave a stale promise online.
  return valid(end) && (!start || valid(start)) && (!start || start <= end) && (!start || today >= start) && today <= end;
}

class DaisyHolidayOrderNotice extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.refresh();
    this.timer = setInterval(() => this.refresh(), 30000);
    document.addEventListener('visibilitychange', () => this.refresh(), { signal: this.controller.signal });
  }

  refresh(now = new Date()) {
    const today = holidayOrderBusinessDate(now, this.dataset.timeZone || 'America/Chicago');
    const hidden = !holidayOrderIsCurrent(this.dataset.startDate, this.dataset.endDate, today);
    if (this.hidden !== hidden) {
      this.hidden = hidden;
      this.dispatchEvent(new CustomEvent('holiday-notice:change', { bubbles: true }));
    }
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    this.controller?.abort();
    this.controller = null;
  }
}

if (!customElements.get('daisy-holiday-order-notice')) customElements.define('daisy-holiday-order-notice', DaisyHolidayOrderNotice);
